function stringifyId(value) {
  if (value == null) return "";
  if (typeof value === "object") {
    if (typeof value.$oid === "string") return value.$oid;
    if (value._id != null) return stringifyId(value._id);
    if (typeof value.id === "string") return value.id;
    return "";
  }
  return String(value);
}

/**
 * @param {Array<{ contactoId?: unknown, count?: unknown }>} rows
 * @returns {string}
 */
function unreadByContactSignature(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return "";
  return rows
    .map((row) => [
      stringifyId(row?.contactoId),
      Number(row?.count ?? 0) || 0,
      String(row?.nombre ?? ""),
      String(row?.email ?? ""),
      String(row?.rol ?? row?.rolGlobal ?? ""),
      String(row?.identidadKey ?? ""),
    ].join(":"))
    .sort((left, right) => left.localeCompare(right))
    .join("|");
}

/**
 * @param {Array<{ contactoId?: unknown, count?: unknown }>} left
 * @param {Array<{ contactoId?: unknown, count?: unknown }>} right
 * @returns {boolean}
 */
export function areUnreadByContactEqual(left, right) {
  return unreadByContactSignature(left) === unreadByContactSignature(right);
}
